/* PARWIN: tint category + product cards with each image's most vibrant colour */
(function () {
  if (window.__parwinCardTint) return; window.__parwinCardTint = true;

  function smallUrl(u) {                       // tiny sample image = fast on big grids
    if (!u) return u;
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&]width=)\d+/, '$1120');
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120';
  }
  function vibrant(img) {
    try {
      var n = 24, c = document.createElement('canvas');
      c.width = c.height = n;
      var x = c.getContext('2d');
      x.drawImage(img, 0, 0, n, n);
      var d = x.getImageData(0, 0, n, n).data, best = null, score = -1;
      for (var i = 0; i < d.length; i += 4) {
        var r = d[i], g = d[i + 1], b = d[i + 2], a = d[i + 3];
        if (a < 200) continue;
        var mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 510;
        if (l > 0.92 || l < 0.12) continue;
        var s = mx === mn ? 0 : (mx - mn) / (mx + mn > 255 ? (510 - mx - mn) : (mx + mn));
        var sc = s * (1 - Math.abs(l - 0.5));
        if (sc > score) { score = sc; best = [r, g, b]; }
      }
      return best;
    } catch (e) { return null; }
  }
  function tint(srcUrl, wrap) {
    if (!srcUrl || !wrap) return;
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      var col = vibrant(im);
      if (col) wrap.style.setProperty('--card-tint', 'rgb(' + col[0] + ',' + col[1] + ',' + col[2] + ')');
    };
    im.src = smallUrl(srcUrl);
  }
  function run() {
    document.querySelectorAll('.collection-card__image').forEach(function (w) {
      var img = w.querySelector('img');
      if (img) tint(img.currentSrc || img.src, w);
    });
    document.querySelectorAll('.card-gallery').forEach(function (w) {
      var img = w.querySelector('.product-media__image') || w.querySelector('img');
      if (img) tint(img.currentSrc || img.src, w);   // tint set on .card-gallery, inherits to .product-media
    });
  }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
